/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")




export interface API47832Req {
  
  /** 汇报编号 */
  reportNo?: string;
  /** 项目编号 */
  projectNo?: string;
};



export type API47832Res = {};


// 47832 删除项目汇报

export interface IUsePostAPI47832Return {
  /** 删除项目汇报: 接口请求状态 */
  isAPI47832Loading: boolean;
  /** 删除项目汇报: 接口请求返回数据 */
  dataAPI47832: API47832Res;
  /**  删除项目汇报: 接口数据请求方法 */
  fetchAPI47832Data:  (inputs: API47832Req, config?: YWRequestConfig) => Promise<API47832Res>;
  /** 删除项目汇报: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI47832 = ():IUsePostAPI47832Return => {
  let isMount = true;
  const [isAPI47832Loading, setIsAPI47832Loading] = useState(false);
  const [dataAPI47832, setDataAPI47832] = useState<API47832Res>({} as API47832Res);
  const requestUrl = `${basePath}/corp-admin/project/report/delete`;

  const fetchAPI47832Data = async (inputs: API47832Req, config?: YWRequestConfig): Promise<API47832Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47832Req>) || {}) as API47832Req;
    
  
    if ( isMount ) {
      setIsAPI47832Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API47832Res>(`${basePath}/corp-admin/project/report/delete`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI47832(res || {} as API47832Res);
        setIsAPI47832Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47832Loading(false);
      }
      return false as unknown as API47832Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47832Loading,
    dataAPI47832,
    fetchAPI47832Data,
    requestUrl,
  }
}

